import React from 'react';
import iiitdlogo from './iiitdlogo.jpg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons'; // Correct import for brand icons

const Footer = () => {
  return (
    <footer className="primary-footer">
      <div className="copyright-wrap">
        <div className="panel">
          <div className="content">
            <p>
              <img src={iiitdlogo} alt="IIITD" />
            </p>
            <p>
              Copyright &copy; 2024 &nbsp;All rights reserved.
              <br />
              <a rel="license" href="http://creativecommons.org/licenses/by-nc-sa/3.0/">
                <img alt="Creative Commons License" style={{ borderWidth: 0 }} src="https://i.creativecommons.org/l/by-nc-sa/3.0/88x31.png" />
              </a>
              <br />
              This work is licensed under a 
              <a href="http://creativecommons.org/licenses/by-nc-sa/3.0/" style={{ fontWeight: 'bold' }}> Creative Commons Attribution-NonCommercial-ShareAlike 3.0 Unported License</a>.
            </p>
            <p>
              <a href="https://iiitd.ac.in/" target="_blank" rel="noopener noreferrer">
                <strong>Indraprastha Institute of Information Technology Delhi (IIIT-Delhi) </strong>
              </a>
              |
              <a href="https://cosylab.iiitd.edu.in/" target="_blank" rel="noopener noreferrer"> Prof. Ganesh Bagler</a>
            </p>
            <p>
              <a href="https://www.facebook.com/ganesh.bagler" target="_blank" rel="noopener noreferrer" style={{ marginRight: '10px' }}>
                <FontAwesomeIcon icon={faFacebook} size="2x" />
              </a>
              <a href="https://twitter.com/gansbags" target="_blank" rel="noopener noreferrer" style={{ marginRight: '10px' }}>
                <FontAwesomeIcon icon={faTwitter} size="2x" />
              </a>
              <a href="https://www.linkedin.com/in/ganeshbagler" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faLinkedin} size="2x" />
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
